import React from 'react';
import { useLocation } from 'react-router-dom';
import RoutesList from './routes';
import { useAuth } from './contexts';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { AppLoader } from './components/AppLoader';
import './styles/App.scss';

const HIDE_FOOTER_ROUTES = ['/onboarding', '/recommended-program'];

function App() {
  const { signed } = useAuth();
  const location = useLocation();

  const hideFooter = HIDE_FOOTER_ROUTES.includes(location.pathname);

  return (
    <div className="App">
      <AppLoader />
      <Header />
      <div className="page-container">{signed !== null && <RoutesList />}</div>
      {!hideFooter && <Footer />}
    </div>
  );
}

export default App;
